import React from 'react';
import { UserCheckIcon, UserXIcon } from 'lucide-react';
export function AudienceSection() {
  return <section className="py-20 bg-stone-100" data-id="element-1">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-3">
          {/* Who this is for */}
          <div className="bg-white rounded-3xl p-8 md:p-10 shadow-sm border-t-4 border-t-green-500" data-id="element-4">
            <div className="flex items-center mb-8" data-id="element-5">
              <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mr-4" data-id="element-6">
                <UserCheckIcon className="w-6 h-6 text-green-600" data-id="element-7" />
              </div>
              <h3 className="text-2xl font-serif font-bold text-stone-900" data-id="element-8">
                Para quién es esto
              </h3>
            </div>

            <ul className="space-y-6" data-id="element-9">
              {['Padres con niños pequeños que sienten que el desorden los gana todos los días.', 'Profesionales con jornadas largas que solo quieren llegar a un hogar en paz.', 'Personas que viven en espacios pequeños donde el desorden se nota el doble.', 'Cualquiera que haya sentido vergüenza de abrir su puerta a un vecino o amigo.'].map((item, i) => <li key={i} className="flex items-start" data-id="element-10">
                  <div className="w-2 h-2 bg-green-500 rounded-full mt-2.5 mr-4 flex-shrink-0" data-id="element-11"></div>
                  <span className="text-stone-700 text-lg" data-id="element-12">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* Who this is NOT for */}
          <div className="bg-white rounded-3xl p-8 md:p-10 shadow-sm border-t-4 border-t-red-500 opacity-90" data-id="element-13">
            <div className="flex items-center mb-8" data-id="element-14">
              <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center mr-4" data-id="element-15">
                <UserXIcon className="w-6 h-6 text-red-600" data-id="element-16" />
              </div>
              <h3 className="text-2xl font-serif font-bold text-stone-900" data-id="element-17">
                Para quién NO es
              </h3>
            </div>

            <ul className="space-y-6" data-id="element-18">
              {['Personas que buscan un curso de limpieza profunda de 8 horas.', 'Quienes tienen una obsesión clínica con la limpieza y no aceptan soluciones tácticas.', "Quienes no están dispuestos a 'esconder' el desorden por unas horas para ganar paz mental."].map((item, i) => <li key={i} className="flex items-start" data-id="element-19">
                  <div className="w-2 h-2 bg-red-400 rounded-full mt-2.5 mr-4 flex-shrink-0" data-id="element-20"></div>
                  <span className="text-stone-600 text-lg" data-id="element-21">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}